/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status shown in the eFax list. REFERRAL_CREATED only matches faxes linked to a lead, and ERROR covers every errored fax that is not.
 * @export
 */
export const FaxStatusFilter = {
    ReferralCreated: 'REFERRAL_CREATED',
    ReferralDeleted: 'REFERRAL_DELETED',
    ReferralNotCreatedSpam: 'REFERRAL_NOT_CREATED_SPAM',
    ReferralNotCreatedSupportingDoc: 'REFERRAL_NOT_CREATED_SUPPORTING_DOC',
    Pending: 'PENDING',
    Error: 'ERROR',
} as const;
export type FaxStatusFilter = typeof FaxStatusFilter[keyof typeof FaxStatusFilter];


export function instanceOfFaxStatusFilter(value: any): boolean {
    for (const key in FaxStatusFilter) {
        if (Object.prototype.hasOwnProperty.call(FaxStatusFilter, key)) {
            if (FaxStatusFilter[key as keyof typeof FaxStatusFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FaxStatusFilterFromJSON(json: any): FaxStatusFilter {
    return FaxStatusFilterFromJSONTyped(json, false);
}

export function FaxStatusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxStatusFilter {
    return json as FaxStatusFilter;
}

export function FaxStatusFilterToJSON(value?: FaxStatusFilter | null): any {
    return value as any;
}

export function FaxStatusFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): FaxStatusFilter {
    return value as FaxStatusFilter;
}

